import React from 'react';
import { Card, Button, Table, Badge } from 'react-bootstrap';
import { Home, Plus, Eye, Edit3 } from 'lucide-react';

const PropertyManager: React.FC = () => {
  const myListings = [
    { 
      id: 1, 
      address: '123 Main St, Phoenix, AZ', 
      price: 485000, 
      status: 'active', 
      views: 45, 
      interested: 8, 
      daysOnMarket: 12 
    },
    { 
      id: 2, 
      address: '456 Oak Ave, Scottsdale, AZ', 
      price: 625000, 
      status: 'pending', 
      views: 67, 
      interested: 12, 
      daysOnMarket: 8 
    },
    { 
      id: 3, 
      address: '789 Pine Rd, Tempe, AZ', 
      price: 395000, 
      status: 'active', 
      views: 23, 
      interested: 3, 
      daysOnMarket: 25 
    }
  ];

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    }).format(price);
  };

  const getStatusBadge = (status: string) => {
    const statusMap = {
      'active': 'success',
      'pending': 'warning',
      'sold': 'primary',
      'expired': 'secondary'
    };
    return statusMap[status as keyof typeof statusMap] || 'secondary';
  };

  return (
    <Card className="border-0 shadow-sm">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">
          <Home size={20} className="me-2" />
          My Listings
        </h5>
        <Button variant="primary">
          <Plus size={16} className="me-2" />
          Add New Listing
        </Button>
      </Card.Header>
      <Card.Body>
        <Table hover responsive>
          <thead>
            <tr>
              <th>Property</th>
              <th>Price</th>
              <th>Status</th>
              <th>Views</th>
              <th>Interested</th>
              <th>Days on Market</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {myListings.map((listing) => (
              <tr key={listing.id}>
                <td>
                  <strong>{listing.address}</strong>
                </td>
                <td>{formatPrice(listing.price)}</td>
                <td>
                  <Badge bg={getStatusBadge(listing.status)}>
                    {listing.status}
                  </Badge>
                </td>
                <td>
                  <Eye size={14} className="text-muted me-1" />
                  {listing.views}
                </td>
                <td>
                  <span className="text-danger">{listing.interested}</span>
                </td>
                <td>{listing.daysOnMarket} days</td>
                <td>
                  <div className="d-flex gap-1">
                    <Button variant="outline-primary" size="sm">
                      <Edit3 size={14} />
                    </Button>
                    <Button variant="outline-info" size="sm">
                      <Eye size={14} />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default PropertyManager;